module.exports = __webpack_public_path__ + "static/media/5.ed4669db.webp";